// extracted by mini-css-extract-plugin
export default {"wrapper":"MainPage_wrapper__SQ2nS","body":"MainPage_body__IWQum","links":"MainPage_links__uMVSf","bottles":"MainPage_bottles__niP+W"};